module.exports = __webpack_public_path__ + "img/registers.a1775ea5.svg";